import * as types from './mutations-types'

export default {
  [types.setUserPermissions] (state, userPermissions) {
    state.userPermissions = userPermissions
    window.localStorage.setItem('userPermissions', JSON.stringify(userPermissions) || [])
  }
}



// WEBPACK FOOTER //
// ./src/app/components/shareds/authorized-link/vuex/mutations.js